<template>
  <div class="hmnews">
    <div class="hmnewsCon">
      <p class="hmnews_tit wow fadeInUp">新闻资讯</p>
      <div class="hmnewsBox clearfix wow fadeInUp">
        <div class="hmnews_li" v-for=" (val, key) in data" :key="key" @click="toDetail(val.id)">
          <div class="hmnews_li_tp">
            <img :src="val.pic" class="npic1" />
          </div>
          <p class="hmnews_li_p1">{{ val.ptime }}<span class="hmnews_li_sp">{{ val.week }}</span></p>
          <p class="hmnews_li_p2">{{ val.title }}</p>
          <div class="hmnews_more">
            <span class="hmnews_more_sp">了解详情</span>
            <i class="morear"></i>
          </div>
        </div>
      </div>
      <p class="newmore"><a href="javascript:;" class="noew_ad wow fadeInUp"  @click="toNews()">查看更多</a></p>
    </div>
  </div>
</template>
<script>
import { WOW } from 'wowjs'
  export default {
    data () {
      return {
        data:[]
      }
    },
    created () {
    },

    mounted () {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      let wow = new WOW({
        live: false,
      })
      wow.init()

      this.$post("/api/homeNews", {
        platform:'pc',
        length:3
      }).then((resp) => {
          if (resp.code == 1) {
            this.data = resp.data;
          }
      }).catch(function(error) {})
    })
    },
    methods: {
    toNews(){
        this.$router.push({
            name: 'news',
            query: {
              // type: type,
            },
          })
      },
       toDetail(id){
       this.$router.push({
            name: 'newsDetail',
            query: {
              id:id
            },
          })
    }
    },
   
  }
</script>


// WEBPACK FOOTER //
// src/components/home/news.vue